// TO DO consolidate with earlyStyles
import styled from 'styled-components'

import { Heading } from '@h2/components/typography/heading'
import { museoFont } from '@h2/components/mixins'

const MuseoHeading = styled(Heading)`
  ${museoFont}
  font-weight: ${({ weight }) => (weight === 'light' ? '700' : '900')};

  > span {
    font-weight: 500;
  }
`

export { MuseoHeading }
